import { DEMO_CALCULATOR_STEP } from 'config/constants'
import {
  DEMO_BANK_COMMISSION_INVOICE_READY_EVENT,
  DEMO_STEP_DELAY,
  DEMO_STEP_PLAYBACK_COMPLETE_EVENT,
} from '../../playback-constants'
import {
  animateDemoPlayerAction,
  restoreFields,
  wait,
  waitForDocumentElement,
  waitForEnabledDocumentElement,
} from '../../helpers'

export const playBankCommissionStep = async ({
  controls,
  fields,
  onComplete,
  stepElement,
}: BankCommissionStepParams): Promise<boolean> => {
  const invoiceElements = Array.from(
    stepElement.querySelectorAll<HTMLElement>('.invoice[data-demo-bank-commission-invoice]'),
  )

  for (const invoiceElement of invoiceElements) {
    const invoiceId = invoiceElement.dataset.demoBankCommissionInvoice
    const invoiceFields = fields.filter(field => invoiceElement.contains(field.element))

    if (!invoiceId || !invoiceFields.length) {
      return false
    }

    controls.showFields(invoiceFields)

    const hasTypedInvoice = await controls.typeFields(invoiceFields)

    if (!hasTypedInvoice) {
      return false
    }

    controls.dispatchEvent(new CustomEvent(DEMO_BANK_COMMISSION_INVOICE_READY_EVENT, {
      detail: { invoiceId },
    }))

    const saveInvoiceAction = await waitForEnabledDocumentElement(
      `[data-demo-playback-action="save-bank-commission-invoice"]` +
      `[data-demo-bank-commission-invoice="${invoiceId}"]`,
      controls.isCancelled,
    )

    if (!saveInvoiceAction) {
      return false
    }

    await animateDemoPlayerAction({ action: saveInvoiceAction, isCancelled: controls.isCancelled })
    saveInvoiceAction.click()

    const completedInvoice = await waitForDocumentElement(
      `.invoice[data-demo-bank-commission-invoice="${invoiceId}"] .payments-tabs-completed`,
      controls.isCancelled,
    )

    if (!completedInvoice) {
      return false
    }

    restoreFields(invoiceFields)
    controls.showFields([])
    controls.setActiveFieldElement(null)
    await wait(DEMO_STEP_DELAY)
  }

  const saveBankCommissionsAction = await waitForEnabledDocumentElement(
    '[data-demo-playback-action="save-bank-commissions"]',
    controls.isCancelled,
  )

  if (!saveBankCommissionsAction) {
    return false
  }

  await animateDemoPlayerAction({ action: saveBankCommissionsAction, isCancelled: controls.isCancelled })
  saveBankCommissionsAction.click()

  const bankCommissionsAreSaved = await waitForDocumentElement(
    '[data-demo-playback-action="save-bank-commissions"]' +
    '[data-demo-playback-complete="true"]',
    controls.isCancelled,
  )

  if (!bankCommissionsAreSaved) {
    return false
  }

  controls.dispatchEvent(new CustomEvent(DEMO_STEP_PLAYBACK_COMPLETE_EVENT, {
    detail: { step: DEMO_CALCULATOR_STEP.BANKING_COMMISSIONS },
  }))
  onComplete()
  controls.clearFields(fields)

  return true
}
